import { api } from "../../../utils/api";

const newsApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    // NewsApiApiSlice.js
    getAllNews: builder.query({
      query: ({ page = 1, pageSize = 10, filter, keyword, count } = {}) => {
        let url = `/news?page=${page}&page_size=${pageSize}`;
        if (filter) {
          url += `&filter=${filter}`;
        }
        if (keyword) {
          url += `&search=${encodeURIComponent(keyword)}`;
        }
        if (count) {
          url += `&limit=${count}`;
        }
        return url;
      },
    }),

    getSingleNews: builder.query({
      query: (newsSlug) => {
        return `/news/${newsSlug}`
      },
    }),
    getNewsPageFields: builder.query({
      query: (newsSlug) => {
        return `/exampleprovider/news/`
      },
    }),
    incrementNewsViewCount: builder.mutation({
      query: (values) => {
        return {
          url: `/news/register/${values.newsId}/view`,
          method: 'POST',
          body: values,
        }
      },
    })
  }),
})

export const { useGetAllNewsQuery, useGetSingleNewsQuery, useGetNewsPageFieldsQuery, useIncrementNewsViewCountMutation } = newsApiSlice;
